import {
	CreateDashboardParams,
	ExtendedDashboardProps,
	BuildDashboardContext,
} from './types';
import { createNewDashboard } from '@/services/dashboards/dashboards-service';
import { nanoidHex } from '@/utils/id-utils';
import { devDebug } from '@/utils/dev-debug';
import { WidgetProps } from '@sisense/sdk-ui';

export const createDashboard = async (
	{ dashboardTitle, widgetIdsToAdd }: CreateDashboardParams,
	context: BuildDashboardContext,
) => {
	const { dataSourceTitle, getWidgetList, saveDashboard, httpClient } =
		context;
	devDebug('toolCall', {
		tool: 'createDashboard',
		dashboardTitle,
		widgetIdsToAdd,
	});

	let newWidgetList: WidgetProps[] = [];
	try {
		newWidgetList =
			(widgetIdsToAdd && widgetIdsToAdd.length > 0
				? getWidgetList?.(widgetIdsToAdd)
				: []) || [];
	} catch (error) {
		console.error(
			'Error: Failed to locate input chart widgets. Empty widget list will be used.',
			error,
		);
	}

	const dashboardProps: ExtendedDashboardProps = await createNewDashboard(
		dataSourceTitle,
		dashboardTitle || `Dashboard for ${dataSourceTitle}`,
		newWidgetList,
		httpClient,
	);

	// generate a new artifact id for the dashboard
	dashboardProps.artifactId = nanoidHex();

	saveDashboard?.(dashboardProps);

	return {
		message:
			newWidgetList.length > 0
				? 'Dashboard created successfully. Click "Save" to persist to My Dashboards.'
				: 'Dashboard created with no chart widgets. Run the createChartWidgetForDashboard tool to create one.',
	};
};
